customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = !1;
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[id^="ProductSubmitButton-"]');
        this.buyButton = this.querySelector('[id^="ProductBuyButton-"]');
        if (document.documentElement.classList.contains("cart-mode-pending")) {
          this.lockForCartMode();
        }
        this.form.addEventListener("submit", async (e) => {
          e.preventDefault();
          if (this._customCartSubmitLocked) return;
          const showCustomCart = localStorage.getItem("showCustomCart");
          if (showCustomCart === "false") {
            this.onSubmitHandler(e);
            return;
          }
          const isBuyNow = !!(
            e.submitter && e.submitter.id.startsWith("ProductBuyButton-")
          );
          const busyBtn = isBuyNow ? this.buyButton : this.submitButton;
          this._customCartSubmitLocked = true;
          if (typeof setCustomCartButtonBusy === "function") {
            setCustomCartButtonBusy(busyBtn, true);
          }
          try {
            if (showCustomCart !== "true") {
              if (typeof waitForShowCustomCartFlag === "function") {
                await waitForShowCustomCartFlag();
              }
            }
            if (localStorage.getItem("showCustomCart") !== "true") {
              if (typeof setCustomCartButtonBusy === "function") {
                setCustomCartButtonBusy(busyBtn, false);
              }
              this._customCartSubmitLocked = false;
              this.onSubmitHandler(e);
              return;
            }
            if (typeof window.whenCartCountReady === "function") {
              await window.whenCartCountReady();
            }
            const refId =
              typeof waitForCustomCartRefId === "function"
                ? await waitForCustomCartRefId()
                : await generateCustomCartRefId();
            if (!refId) {
              if (typeof setCustomCartButtonBusy === "function") {
                setCustomCartButtonBusy(busyBtn, false);
              }
              return;
            }
            await this.onCustomSubmitHandler(e);
          } catch (err) {
            console.error(err);
            if (typeof setCustomCartButtonBusy === "function") {
              setCustomCartButtonBusy(busyBtn, false);
            }
          } finally {
            this._customCartSubmitLocked = false;
          }
        });
        if (this.buyButton) {
          if (document.querySelector("cart-drawer")) {
            this.submitButton.setAttribute("aria-haspopup", "dialog");
          }
          this.hideErrors = "true" === this.dataset.hideErrors;
        }
        this.setPersonalisedListeners();
        this.setPhotoframeListener();
        this.goldChainAddOns = document.querySelectorAll('[id^="addons_"]');
        this.goldChainAddOns.forEach((t) => {
          t.addEventListener("click", this.goldChainAddOnsHandler.bind(this));
        });
        this.setShowDetailsBtns();
      }

      lockForCartMode() {
        [this.submitButton, this.buyButton].forEach((button) => {
          if (!button || button.dataset.cartModeLock) return;
          button.dataset.cartModeLock = "true";
          if (button.disabled) button.dataset.cartModeWasDisabled = "true";
          button.disabled = true;
          button.setAttribute("aria-disabled", "true");
        });
      }

      unlockForCartMode() {
        [this.submitButton, this.buyButton].forEach((button) => {
          if (!button || button.dataset.cartModeLock !== "true") return;
          delete button.dataset.cartModeLock;
          if (button.dataset.cartModeWasDisabled === "true") {
            delete button.dataset.cartModeWasDisabled;
            return;
          }
          button.disabled = false;
          button.removeAttribute("aria-disabled");
        });
      }

      setShowDetailsBtns() {
        this.viewDetailsBtns = document.querySelectorAll(
          '[id^="buy-view-details-"]',
        );
        if (this.viewDetailsBtns.length > 0) {
          this.viewDetailsBtns.forEach((t) => {
            t.addEventListener("click", () => {
              let originalElement = t.closest(".must_buy_item");
              if (originalElement) {
                originalElement.setAttribute(
                  "data-original-content",
                  originalElement.outerHTML,
                );
                let index = t.id.split("-")[3];
                let ogCheckbox = originalElement.querySelector(
                  `.buy-row-1-${index} input[type="checkbox"]:checked`,
                );
                let buyRow3 = document.querySelector(`.buy-row-3-${index}`);
                if (buyRow3) {
                  originalElement.innerHTML = "";
                  let buyRow3Clone = buyRow3.cloneNode(true);
                  buyRow3Clone.style.display = "flex";
                  originalElement.appendChild(buyRow3Clone);
                  originalElement.classList.add("buy-row-active");
                  if (ogCheckbox) {
                    let rowCheckbox = originalElement.querySelector(
                      `.buy-row-3-${index} input[id="${ogCheckbox.id}_row3"]`,
                    );
                    if (rowCheckbox) {
                      rowCheckbox.checked = true;
                    }
                  }
                  this.setHideDetailsBtns();
                }
              }
            });
          });
        }
      }

      setHideDetailsBtns() {
        this.hideDetailsBtns = document.querySelectorAll(
          '[id^="buy-hide-details-"]',
        );
        if (this.hideDetailsBtns.length > 0) {
          this.hideDetailsBtns.forEach((t) => {
            t.addEventListener("click", () => {
              let originalElement = t.closest(".must_buy_item");
              let index = t.id.split("-")[3];
              let row3Checkbox = originalElement.querySelector(
                `.buy-row-3-${index} input[type="checkbox"]:checked`,
              );
              let originalContent = document.createElement("div");
              originalContent.innerHTML = originalElement.getAttribute(
                "data-original-content",
              );
              originalElement.classList.remove("buy-row-active");
              if (originalContent.firstElementChild) {
                let restoredElement = originalContent.firstElementChild;
                originalElement.replaceWith(restoredElement);
                if (row3Checkbox) {
                  let originalCheckbox = restoredElement.querySelector(
                    `.buy-row-1-${index} input[id="${row3Checkbox.id.replace("_row3", "")}"]`,
                  );
                  if (originalCheckbox) {
                    originalCheckbox.checked = true;
                  }
                }
                this.setShowDetailsBtns();
              }
            });
          });
        }
      }
      setPhotoframeListener() {
        const t = document.querySelectorAll(".photoFrameImg");
        t.length > 0 &&
          t.forEach((t) => {
            t.onchange = () => {
              const e = t.parentElement,
                s = e.querySelector(".photo"),
                r = e.querySelector(".frame"),
                i = t.files[0],
                o = new Image();
              ((o.onload = () => {
                o.width > o.height
                  ? (s.classList.remove("photo-portrait"),
                    s.classList.add("photo-landscape"),
                    r.classList.remove("frame-cover-portrait"),
                    r.classList.add("frame-cover-landscape"))
                  : (s.classList.add("photo-portrait"),
                    s.classList.remove("photo-landscape"),
                    r.classList.remove("frame-cover-landscape"),
                    r.classList.add("frame-cover-portrait"));
              }),
                (o.src = URL.createObjectURL(i)),
                (e.querySelector("#uploadedPf").src = o.src),
                e
                  .querySelectorAll(".noPreviewPf")
                  .forEach((t) => (t.style.display = "none")),
                e
                  .querySelectorAll(".previewPf")
                  .forEach((t) => (t.style.display = "block")));
            };
          });
      }
      setPersonalisedListeners() {
        const t = (e, s) => {
          const r = window.innerWidth < 740 ? 13 : 35,
            i = document.querySelector("div#outer"),
            o = document.querySelector("div#outer div");
          s && (o.style.fontSize = "100px");
          const a = window
            .getComputedStyle(o, null)
            .getPropertyValue("font-size");
          ((o.style.fontSize = parseFloat(a) - 0.3 + "px"),
            o.clientHeight >= i.clientHeight + (window.innerWidth / r) * e &&
              t(e, !1),
            o.clientWidth >= i.clientWidth + (window.innerWidth / r) * e &&
              t(e, !1));
        };
        ((this.letterInputs = this.querySelectorAll(".personalised-input")),
          this.letterInputs.forEach((e, s) => {
            const r = e.querySelector("input"),
              i = e.querySelector("#leftchars"),
              o = e.dataset.max,
              a = e.dataset.caps,
              n = "letters" + (s > 0 ? s + 1 : ""),
              d = document.getElementById(n),
              c = "allowSpace" in e.dataset && "true" === e.dataset.allowSpace,
              l = "resize" in e.dataset && "true" === e.dataset.resize,
              u = "hindi" in e.dataset && "true" === e.dataset.hindi;
            let h;
            r.addEventListener("input", async (s) => {
              if (
                s.target.getAttribute("maxlength") == 1 ||
                s.target.dataset.allCaps
              ) {
                s.target.value = s.target.value.toUpperCase();
              } else if (s.target.dataset.firstCap) {
                s.target.value =
                  s.target.value[0].toUpperCase() + s.target.value.slice(1);
              }
              let r = s.target.value;
              r.length > o && (r = r.slice(0, o));
              let n = 0,
                m = "";
              for (const t of r) {
                if (s.target.dataset.aphanumeric == "true") {
                  m += t;
                } else {
                  (t >= "A" && t <= "Z" && n < a && ((m += t), n++),
                    t >= "a" && t <= "z" && (m += t),
                    t >= 0 && t <= 9 && (m += t),
                    " " === t && c && (m += t));
                }
              }
              ((s.target.value = m),
                i &&
                  ((i.innerHTML = `${o - m.length}/${o}`),
                  (i.style.color = o === m.length ? "red" : "#7D7D7D")),
                d &&
                  (u
                    ? (clearTimeout(h),
                      (h = setTimeout(async () => {
                        if (m.length > 0) {
                          const t = await fetch(
                              `https://prod.giva-api.com/getHindi?text=${m.toUpperCase()}%20`,
                            ),
                            e = await t.json();
                          d.innerHTML = e.data;
                        } else d.innerHTML = m;
                      }, 500)))
                    : (d.innerHTML = m)),
                l &&
                  t(
                    e.dataset.divider && "true" === e.dataset.divider ? 1 : 0,
                    !0,
                  ));
            });
          }));
      }
      async onSubmitHandler(t) {
        t.preventDefault();
        let cartItems = [];
        await fetch(routes.cart_url, fetchConfig())
          .then((t) => t.text())
          .then((t) => {
            cartItems = JSON.parse(t).items;
          });
        const e = !!t.submitter.id.startsWith("ProductBuyButton-");
        if (
          this.submitButton &&
          (t && "function" == typeof t.preventDefault && t.preventDefault(),
          "true" === this.submitButton.getAttribute("aria-disabled"))
        )
          return;
        const i = new FormData(this.form);
        this.pairWithInput = document.querySelectorAll('[id^="pair_it_with_"]');
        let toBeAddedItems = [];
        if (window.location.href.includes("/products/") && isPairBtnClicked) {
          document
            .querySelector("#pair-button-main")
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
          document
            .querySelector("#pair-button-main")
            .querySelector("#pair-button-text")
            .classList.add("pair-text-hidden");
          this.pairWithInput.forEach((t) => {
            if (t.type === "checkbox" && t.checked) {
              const pairId = t.id.split("pair_it_with_")[1];
              const pairVal = document.getElementById(
                `pair_it_with_input_${pairId}`,
              ).value;
              const pairSkuType = document.getElementById(
                `pair_it_with_input_${pairId}`,
              ).dataset.skuType;
              if (pairVal != i.get("id")) {
                if (
                  cartItems.length === 0 ||
                  (cartItems.length > 0 &&
                    cartItems.filter((item) => item.id == pairVal).length === 0)
                ) {
                  toBeAddedItems.push({ pairVal, pairSkuType });
                }
              }
            }
          });
          if (
            cartItems.length > 0 &&
            cartItems.filter((item) => item.id == i.get("id")).length > 0
          ) {
            i.delete("id");
            if (toBeAddedItems.length > 0) {
              i.append("id", toBeAddedItems[0].pairVal);
              i.append("properties[type]", toBeAddedItems[0].pairSkuType);
              if (toBeAddedItems[0].pairSkuType === "personalised") {
                i.append("properties[facility_id]", "16221405274-8");
                i.append("properties[facility_name]", "jpr-warehouse");
              }
              toBeAddedItems.shift();
            } else {
              return;
            }
          }
        }
        let prodTitle = "";
        let prodPrice = "";
        if (window.location.href.includes("/products/")) {
          prodTitle = document.querySelector(".main__title")
            ? document.querySelector(".main__title").textContent.trim()
            : document.querySelector(".prod_desc_title")
              ? document.querySelector(".prod_desc_title").textContent.trim()
              : "";
          prodPrice = document
            .querySelector(".price-item--sale")
            .textContent.trim()
            .replace("₹", "")
            .replace(/,/g, "");
        } else {
          prodTitle =
            this.closest(".grid__item").querySelector("#hidden_title").value;
          prodPrice = this.closest(".grid__item")
            .querySelector("#hidden_price")
            .value.replace("₹", "")
            .replace(/,/g, "");
        }
        if (cartItems.length == 0) {
          fireCartCreatedEvent(prodTitle, prodPrice);
        }
        let collectionId = document.querySelector("#hidden-collection-id")
          ? document.querySelector("#hidden-collection-id").value
          : "";
        if (typeof window !== "undefined" && window?.auditzy) {
          window?.auditzy?._queue.push({
          event: 'conversion_track', // don't change this
          action: 'add_to_cart', // don't change this
          })
        }
        // Analytics must not block the cart request: fireAddToCartEvent waits for CleverTap to
        // load, which can take seconds (or never happen when it is blocked).
        fireAddToCartEvent(
          document.querySelector("delivery-time #time1")
            ? document.querySelector("delivery-time #time1").textContent
            : "",
          i.get("id"),
          collectionId,
          prodTitle,
          prodPrice,
        ).catch(() => {});
        (this.handleErrorMessage(),
          this.submitButton &&
            (this.submitButton.setAttribute("aria-disabled", !0),
            e || this.submitButton.classList.add("loading")),
          this.buyButton &&
            (this.buyButton.setAttribute("aria-disabled", !0),
            e && this.buyButton.classList.add("loading")));
        const s = e
          ? this.buyButton
            ? this.buyButton.querySelector(".loading-overlay__spinner")
            : null
          : this.submitButton.querySelector(".loading-overlay__spinner");
        s && s.classList.remove("hidden");
        const r = fetchConfig("javascript");
        ((r.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete r.headers["Content-Type"]);
        this.cart &&
          (i.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id),
          ),
          i.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement));
        if (
          i.has("properties[_giftWrap]") &&
          "yes" === i.get("properties[_giftWrap]")
        ) {
          i.append("properties[_giftWrapWidget]", "pdp-gift_wrap");
        }
        r.body = i;
        const o =
            i.has("properties[_giftWrap]") &&
            "yes" === i.get("properties[_giftWrap]"),
          a = Array.from(this.goldChainAddOns).filter((t) => t.checked)[0];
        let n = false;
        Array.from(document.getElementsByClassName("box_addons")).forEach(
          (t) => {
            if (t.checked) {
              n = true;
            }
          },
        );
        (e,
          fetch("" + routes.cart_add_url, r)
            .then((t) => t.json())
            .then(async (t) => {
              const s = [],
                r = { ...t };
              if ((o && s.push({ id: 31471233106010, quantity: 1 }), a)) {
                const t = document.getElementById("productId-" + a.id).value;
                s.push({ id: t, quantity: 1 });
              }
              if (n) {
                Array.from(
                  document.getElementsByClassName("box_addons"),
                ).forEach((t) => {
                  if (t.checked) {
                    const e = t.previousElementSibling.value;
                    s.push({
                      id: e,
                      quantity: 1,
                      properties: {
                        type: t.previousElementSibling.dataset.skuType,
                      },
                    });
                  }
                });
              }
              if (
                window.location.href.includes("/products/") &&
                isPairBtnClicked
              ) {
                toBeAddedItems.forEach((t) => {
                  s.push({
                    id: t.pairVal,
                    quantity: 1,
                    properties: {
                      _widget: "pdp-pair_it_with",
                      type: t.pairSkuType,
                    },
                  });
                });
              }
              if (
                (s.length > 0 &&
                  ((t = await fetch(routes.cart_add_url + ".js", {
                    method: "POST",
                    body: JSON.stringify({
                      items: s,
                      sections: "cart-icon-bubble,cart-notification-button",
                    }),
                    headers: { "Content-Type": "application/json" },
                  }).then((t) => t.json())),
                  (r.sections["cart-icon-bubble"] =
                    t.sections["cart-icon-bubble"]),
                  (r.sections["cart-notification-button"] =
                    t.sections["cart-notification-button"])),
                t.status)
              ) {
                (publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  errors: t.errors || t.description,
                  message: t.message,
                }),
                  this.handleErrorMessage(t.description));
                const e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                return (
                  this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  e.classList.remove("hidden"),
                  void (this.error = !0)
                );
              }
              if (!this.cart)
                return void (window.location = window.routes.cart_url);
              if (e) {
                this.buyButton &&
                  this.buyButton.removeAttribute("aria-disabled");
                this.submitButton &&
                  this.submitButton.removeAttribute("aria-disabled");
                if (window.openRzpLogin) {
                  (window.openRzpLogin(),
                    this.submitButton.classList.remove("loading"),
                    this.buyButton &&
                      this.buyButton.classList.remove("loading"),
                    this.cart &&
                      this.cart.classList.contains("is-empty") &&
                      this.cart.classList.remove("is-empty"));
                  const t =
                    this.buyButton &&
                    this.buyButton.querySelector(".loading-overlay__spinner");
                  t && t.classList.add("hidden");
                } else window.location = "/cart";
              }
              (this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  cartData: t,
                }),
                (this.error = !1));
              const d =
                this.closest("quick-add-modal") ||
                document.querySelector("quick-add-modal[open]");
              (d
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(t);
                      });
                    },
                    { once: !0 },
                  ),
                  d.hide(!0))
                : e ||
                  window.location.pathname === window.routes.cart_url ||
                  this.cart.renderContents(r),
                (this.submitButton.innerHTML = "Added to Cart"));
              if (
                window.location.href.includes("/products/") &&
                isPairBtnClicked
              ) {
                isPairBtnClicked = false;
                document
                  .querySelector("#pair-button-main")
                  .querySelector("#pair-button-text").innerHTML =
                  "Added to Cart";
              }
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(async () => {
              (e ||
                (this.submitButton.classList.remove("loading"),
                this.buyButton && this.buyButton.classList.remove("loading")),
                this.cart &&
                  this.cart.classList.contains("is-empty") &&
                  this.cart.classList.remove("is-empty"),
                this.error ||
                  e ||
                  (this.submitButton.removeAttribute("aria-disabled"),
                  this.buyButton &&
                    this.buyButton.removeAttribute("aria-disabled")),
                !e && s && s.classList.add("hidden"));
              if (t.submitter.classList.contains("wishlist-quick-add")) {
                document
                  .getElementById("cart-notification-overlay")
                  .classList.remove("active");
                const wishViewList =
                  document.getElementsByTagName("wish-view-list")[0];
                wishViewList.deleteWishItem(t.submitter.dataset.handle);
                document.getElementById("moved-to-cart").style.display = "flex";
                setTimeout(function () {
                  document.getElementById("moved-to-cart").style.display =
                    "none";
                }, 5000);
              }
              if (document.querySelector("#pair-button-main")) {
                document
                  .querySelector("#pair-button-main")
                  .querySelector(".loading-overlay__spinner")
                  .classList.add("hidden");
                document
                  .querySelector("#pair-button-main")
                  .querySelector("#pair-button-text")
                  .classList.remove("pair-text-hidden");
              }
            }));
      }
      async onCustomSubmitHandler(t) {
        t.preventDefault();
        let cartItems = [];
        let userId = __st.cid ? `${__st.cid}` : await window.visitor_id;
        let cartId;
        let refId =
          typeof waitForCustomCartRefId === "function"
            ? await waitForCustomCartRefId()
            : await generateCustomCartRefId();
        if (!refId) return;
        let address = {};
        if (localStorage.getItem("sddPincode")) {
          address.zip = localStorage.getItem("sddPincode");
          let selectedAddr = document.querySelector(".del-selected");
          if (selectedAddr) {
            address.line1 = selectedAddr.querySelector(
              "#customer_addr_line1",
            ).value;
            address.line2 = selectedAddr.querySelector(
              "#customer_addr_line2",
            ).value;
            address.city = selectedAddr.querySelector(
              "#customer_addr_city",
            ).value;
            address.state = selectedAddr.querySelector(
              "#customer_addr_state",
            ).value;
            address.country = selectedAddr.querySelector(
              "#customer_addr_country",
            ).value;
          }
        }
        let prodTitle = "";
        let prodPrice = "";
        if (window.location.href.includes("/products/")) {
          prodTitle = document.querySelector(".main__title")
            ? document.querySelector(".main__title").textContent.trim()
            : document.querySelector(".prod_desc_title")
              ? document.querySelector(".prod_desc_title").textContent.trim()
              : "";
          prodPrice = document
            .querySelector(".price-item--sale")
            .textContent.trim()
            .replace("₹", "")
            .replace(/,/g, "");
        } else {
          prodTitle =
            this.closest(".grid__item").querySelector("#hidden_title").value;
          prodPrice = this.closest(".grid__item")
            .querySelector("#hidden_price")
            .value.replace("₹", "")
            .replace(/,/g, "");
        }
        let collectionId = document.querySelector("#hidden-collection-id")
          ? document.querySelector("#hidden-collection-id").value
          : "";
        try {
          const response = await fetch(
            `https://prod-bifrost.giva-api.com/api/cart/user`,
            {
              headers: { ref_access_token: refId },
            },
          );
          if (!response.ok) {
            console.log("No cart found for user");
          } else {
            const data = await response.json();
            if (data.data) {
              cartItems = data.data.cart.items;
              cartId = data.data.cart.id;
              if (cartId.length === 0) {
                cartId = undefined;
              }
            }
          }
        } catch (error) {
          console.log("Cart fetch failed", error);
        }
        const isBuyNow = !!t.submitter.id.startsWith("ProductBuyButton-");
        if (
          this.submitButton &&
          "true" === this.submitButton.getAttribute("aria-disabled")
        )
          return;
        const i = new FormData(this.form);
        if (cartItems.length == 0) {
          fireCartCreatedEvent(prodTitle, prodPrice);
        }
        if (!isBuyNow) {
          // Fire-and-forget: see the note in onSubmitHandler.
          fireAddToCartEvent(
            document.querySelector("delivery-time #time1")
              ? document.querySelector("delivery-time #time1").textContent
              : "",
            i.get("id"),
            collectionId,
            prodTitle,
            prodPrice,
          ).catch(() => {});
        }

        //pair it with prods
        this.pairWithInput = document.querySelectorAll('[id^="pair_it_with_"]');
        let toBeAddedItems = [];

        if (window.location.href.includes("/products/") && isPairBtnClicked) {
          this.pairWithInput.forEach((t) => {
            if (t.type === "checkbox" && t.checked) {
              const pairId = t.id.split("pair_it_with_")[1];

              const pairVal = document.getElementById(
                `pair_it_with_input_${pairId}`,
              ).value;

              const pairSkuType = document.getElementById(
                `pair_it_with_input_${pairId}`,
              ).dataset.skuType;

              if (pairVal != i.get("id")) {
                if (
                  cartItems &&
                  (cartItems.length === 0 ||
                    cartItems.filter((item) => item.product_id == pairVal)
                      .length === 0)
                ) {
                  toBeAddedItems.push({ pairVal, pairSkuType });
                }
              }
            }
          });
        }

        //main prod
        let apiItems = [];
        // Collect all personalisation text fields (text1, text2, ...)
        let personalisation_text = [];
        if (i.has(`properties[Text]`)) {
          const val = i.get(`properties[Text]`);
          personalisation_text.push({ text: val });
        }
        let idx = 1;
        while (i.has(`properties[Text${idx}]`)) {
          const val = i.get(`properties[Text${idx}]`);
          personalisation_text.push({ text: val });
          idx++;
        }

        //gift wrap
        const o =
          i.has("properties[_giftWrap]") &&
          "yes" === i.get("properties[_giftWrap]");
        let personalisation;
        if (o || personalisation_text.length > 0) {
          personalisation = {};
          if (o) {
            personalisation.gift_wrapping = {
              item: {
                item_id: "31471233106010",
              },
            };
          }
          if (personalisation_text.length > 0) {
            personalisation.personalisation_text = personalisation_text;
          }
        }
        let mainItem = {
          item_id: i.get("id"),
          quantity: 1,
        };
        if (personalisation) {
          mainItem.personalisation = personalisation;
        }
        apiItems.push(mainItem);

        let mainProductAdded = {
          product_title: document.querySelector(".main__title")
            ? document.querySelector(".main__title").textContent.trim()
            : document.querySelector(".prod_desc_title")
              ? document.querySelector(".prod_desc_title").textContent.trim()
              : t.target.closest("li").querySelector("#hidden_title").value,
          final_line_price: `₹${prodPrice}`,
          image: document.querySelector(".product__media-wrapper img")
            ? document.querySelector(".product__media-wrapper img").src
            : t.target.closest("li").querySelector(".card__media img").src,
        };

        //gold chain
        const a = Array.from(this.goldChainAddOns).filter((t) => t.checked)[0];
        if (a) {
          const t = document.getElementById("productId-" + a.id).value;
          apiItems.push({
            item_id: t,
            quantity: 1,
          });
        }

        //box addons
        Array.from(document.getElementsByClassName("box_addons")).forEach(
          (t) => {
            if (t.checked) {
              const e = t.previousElementSibling.value;

              apiItems.push({
                item_id: e,
                quantity: 1,
              });
            }
          },
        );

        //pair products
        if (window.location.href.includes("/products/") && isPairBtnClicked) {
          toBeAddedItems.forEach((t) => {
            apiItems.push({
              item_id: t.pairVal,
              quantity: 1,
            });
          });
        }

        this.submitButton &&
          (this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"));

        this.buyButton &&
          (this.buyButton.setAttribute("aria-disabled", !0),
          this.buyButton.classList.add("loading"));

        const s = isBuyNow
          ? this.buyButton.querySelector(".loading-overlay__spinner")
          : this.submitButton.querySelector(".loading-overlay__spinner");

        s && s.classList.remove("hidden");

        //buy now flow
        if (isBuyNow || cartId == undefined) {
          const res = await fetch(
            "https://prod-bifrost.giva-api.com/api/cart",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                ref_access_token: refId,
              },
              body: JSON.stringify({
                cart_type: isBuyNow ? "ephemeral" : "primary",
                user_id: userId,
                items: apiItems,
                payment: { payment_methods: [] },
                benefits: { coupons: [] },
                serviceability_option: { shipments: [] },
                shipping_address: address,
                billing_address: address,
              }),
            },
          );

          const data = await res.json();

          const intentCartId = data?.data?.cart_id || data?.data?.cart?.id;

          this.submitButton.classList.remove("loading");
          this.buyButton && this.buyButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.buyButton && this.buyButton.removeAttribute("aria-disabled");
          s && s.classList.add("hidden");

          if (intentCartId && isBuyNow) {
            window.location.href = `https://checkout.giva.co/cart?cart_id=${intentCartId}&ref_id=${window.latestRefAccessToken ? window.latestRefAccessToken(refId) : refId}`;
          } else {
            if (data.success == true) {
              this.submitButton.innerHTML = "Added to Cart";
              mainProductAdded.totalCartItems = data.data.cart.items
                .filter((item) => item.item_id != "31471233106010")
                .map((item) => item.quantity)
                .reduce((a, b) => a + b, 0);
              document.querySelectorAll(".header__icon--cart").forEach((el) => {
                if (el.getAttribute("id") == "cart-icon-bubble") {
                  el.querySelector("#cart-count-bubble")
                    .querySelectorAll("span")
                    .forEach((span) => {
                      span.innerHTML = mainProductAdded.totalCartItems;
                    });
                }
              });
              this.closeQuickAddModal();
              this.createCustomNotificationPopup(mainProductAdded);
            }
          }

          return;
        }

        //add to cart flow
        const res = await fetch(
          "https://prod-bifrost.giva-api.com/api/cart/update-items",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ref_access_token: refId,
            },
            body: JSON.stringify({
              cart_id: cartId,
              user_id: userId,
              items: apiItems.map((item) => ({
                item: item,
                operation: "add",
              })),
              shipping_address: address,
              billing_address: address,
            }),
          },
        );
        const data = await res.json();
        if (data) {
          this.submitButton.classList.remove("loading");
          this.buyButton && this.buyButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.buyButton && this.buyButton.removeAttribute("aria-disabled");
          s && s.classList.add("hidden");
          if (data.success == true) {
            this.submitButton.innerHTML = "Added to Cart";
            mainProductAdded.totalCartItems = data.data.cart.items
              .map((item) => item.quantity)
              .reduce((a, b) => a + b, 0);
            document.querySelectorAll(".header__icon--cart").forEach((el) => {
              if (el.getAttribute("id") == "cart-icon-bubble") {
                el.querySelector("#cart-count-bubble")
                  .querySelectorAll("span")
                  .forEach((span) => {
                    span.innerHTML = mainProductAdded.totalCartItems;
                  });
              }
            });
            this.closeQuickAddModal();
            this.createCustomNotificationPopup(mainProductAdded);
          }
        }
        window.dataLayer?.push({
          event: "dl_add_to_cart",
          event_time: new Date().toISOString(),
          ecommerce: {
            add: {
              products: [
                {
                  product_id: i.get("id"),
                  name: prodTitle,
                  price: prodPrice,
                  quantity: 1,
                  url: window.location.href.includes("/products/")
                    ? window.location.href
                    :
                        t?.target
                          ?.closest?.("li, .grid__item, .card-wrapper, .card")
                          ?.querySelector?.("a[href]")?.href || window.location.href,
                  list: window.location.href.includes("/products/")
                    ? document.referrer
                    : window.location.href,
                  brand: "GIVA Jewelry",
                },
              ],
            },
            currencyCode: window.currencyCode,
          },
        });
      }
      closeQuickAddModal() {
        const modal =
          this.closest("quick-add-modal") ||
          document.querySelector("quick-add-modal[open]");
        if (modal && typeof modal.hide === "function") {
          modal.hide(true);
        }
      }
      createCustomNotificationPopup(item) {
        const popupHTML = `<cart-notification class="custom-cart-notification">
          <div class="cart-notification-overlay active" id="cart-notification-overlay">
            <div class="cart-notification-wrapper page-width">
              <div id="cart-notification" class="cart-notification focus-inset color-background-1 gradient animate active" aria-modal="true" aria-label="Item added to your cart" role="dialog" tabindex="-1">
                <div class="cart-notification__header">
                  <div class="cart-notification__heading caption-large text-body"><svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path>
        </svg>
        Item added to your cart
                  </div>
                  <button type="button" class="cart-notification__close modal__close-button link link--text focus-inset" aria-label="Close">
                    <svg class="icon icon-close" aria-hidden="true" focusable="false">
                      <use href="#icon-close">
                    </use></svg>
                  </button>
                </div>
                <div id="cart-notification-product" class="cart-notification-product"><div class="cart-notification-product__image global-media-settings">
                  <img src="${item.image}" alt="" width="70" height="70" loading="lazy">
                </div><div><h3 class="cart-notification-product__name h4">${item.product_title}</h3>
                <h3 class="cart-notification-product__price h4">${item.final_line_price}</h3>
                </div>
            </div>
                <div class="cart-notification__links">
                  <button type="button" class="button button--secondary button--full-width view-cart-btn">View cart (${item.totalCartItems})</button>
                  <button type="button" class="link button-label medium-hide large-up-hide">Continue shopping</button>
                </div>
              </div>
            </div>
          </div>
        </cart-notification>`;
        const header = document.body.querySelector(
          ".shopify-section-header-sticky",
        );
        if (!header) return;
        header.insertAdjacentHTML("beforeend", popupHTML);
        const customNotification = header.querySelector(
          ".custom-cart-notification:last-of-type",
        );
        const viewCartBtn =
          customNotification && customNotification.querySelector(".view-cart-btn");
        if (viewCartBtn) {
          viewCartBtn.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              if (typeof openCustomCartPage === "function") openCustomCartPage();
            },
            true,
          );
        }
        customNotification
          .querySelector(".cart-notification__close")
          .addEventListener("click", () => {
            customNotification.remove();
          });
        customNotification
          .querySelector(".cart-notification__links .button-label")
          .addEventListener("click", () => {
            customNotification.remove();
          });
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message",
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      goldChainAddOnsHandler(t) {
        let e = t.target;
        this.goldChainAddOns.forEach((s) => {
          s.checked &&
            s !== t.target &&
            ((t.target.checked = !1),
            (document.querySelector(".addon_error_box").style.display = "flex"),
            setTimeout(() => {
              document.querySelector(".addon_error_box").style.display = "none";
            }, 3e3),
            (e = s));
        });
      }
    },
  );
